// This file is auto-generated by @hey-api/openapi-ts

import {
  type Options as ClientOptions,
  type TDataShape,
  type Client,
  urlSearchParamsBodySerializer,
} from "@hey-api/client-fetch";
import type {
  CreateMeasurementData,
  CreateMeasurementResponse,
  CreateMeasurementError,
  CreateTransactionData,
  CreateTransactionResponse,
  CreateTransactionError,
  DataRouterPostMeasurementsFromMqttV1DataMqttMeasurementsPostData,
  DataRouterPostMeasurementsFromMqttV1DataMqttMeasurementsPostError,
  DataRouterPostTransactionsFromMqttV1DataMqttTransactionsPostData,
  DataRouterPostTransactionsFromMqttV1DataMqttTransactionsPostError,
  DataRouterPostTransactionEventsFromMqttV1DataMqttTransactionEventsPostData,
  DataRouterPostTransactionEventsFromMqttV1DataMqttTransactionEventsPostError,
  SchemaOnlyControllerMqttPayloadsData,
  SchemaOnlyControllerMqttPayloadsError,
  SchemaOnlyPartnerMqttPayloadsData,
  SchemaOnlyPartnerMqttPayloadsError,
  GetLatestMeasurementsForSiteData,
  GetLatestMeasurementsForSiteResponse,
  GetLatestMeasurementsForSiteError,
  GetLatestMeasurementForSiteData,
  GetLatestMeasurementForSiteResponse,
  GetLatestMeasurementForSiteError,
  GetLatestTransactionsForSiteData,
  GetLatestTransactionsForSiteResponse,
  GetLatestTransactionsForSiteError,
  GetRecentTransactionsForSiteData,
  GetRecentTransactionsForSiteResponse,
  GetRecentTransactionsForSiteError,
  GetCalculatedUclForSiteInArrowData,
  GetCalculatedUclForSiteInArrowError,
  GetPowerOverviewForSiteInArrowData,
  GetPowerOverviewForSiteInArrowError,
  GetSocOverviewForSiteInArrowData,
  GetSocOverviewForSiteInArrowError,
  GetTransactionStatsForSiteData,
  GetTransactionStatsForSiteResponse,
  GetTransactionStatsForSiteError,
  GetDriverSummariesForSiteData,
  GetDriverSummariesForSiteResponse,
  GetDriverSummariesForSiteError,
  GetActiveTransactionsWithEnergyForSiteData,
  GetActiveTransactionsWithEnergyForSiteResponse,
  GetActiveTransactionsWithEnergyForSiteError,
  GetActiveDriverSessionsData,
  GetActiveDriverSessionsResponse,
  OverwriteDriverPreferencesForTransactionData,
  OverwriteDriverPreferencesForTransactionResponse,
  OverwriteDriverPreferencesForTransactionError,
  EndTransactionAsGhostData,
  EndTransactionAsGhostResponse,
  EndTransactionAsGhostError,
  GetLatestMeasurementForAssetData,
  GetLatestMeasurementForAssetResponse,
  GetLatestMeasurementForAssetError,
  GetMeasurementsForSiteData,
  GetMeasurementsForSiteResponse,
  GetMeasurementsForSiteError,
  GetMeasurementsForSiteQuarterHourlyData,
  GetMeasurementsForSiteQuarterHourlyError,
  GetMeasurementsForAssetData,
  GetMeasurementsForAssetResponse,
  GetMeasurementsForAssetError,
  GetMeasurementsForSiteInArrowData,
  GetMeasurementsForSiteInArrowError,
  GetMeasurementsForAssetInArrowData,
  GetMeasurementsForAssetInArrowError,
  GetMeasurementsForAssetInArrowInterpolatedData,
  GetMeasurementsForAssetInArrowInterpolatedError,
  GetTransactionsWithEventsForSiteData,
  GetTransactionsWithEventsForSiteResponse,
  GetTransactionsWithEventsForSiteError,
  GetTransactionsForSiteData,
  GetTransactionsForSiteResponse,
  GetTransactionsForSiteError,
  GetLifecycleAroundActiveTransactionsData,
  GetLifecycleAroundActiveTransactionsResponse,
  GetLifecycleAroundActiveTransactionsError,
  ListFailedMessagesData,
  ListFailedMessagesResponse,
  ListFailedMessagesError,
  ListSitesData,
  ListSitesResponse,
  ListSitesError,
  CreateSiteData,
  CreateSiteResponse,
  CreateSiteError,
  DeleteSiteData,
  DeleteSiteError,
  GetSiteData,
  GetSiteResponse,
  GetSiteError,
  PatchSiteData,
  PatchSiteResponse,
  PatchSiteError,
  UpdateSiteData,
  UpdateSiteResponse,
  UpdateSiteError,
  ValidateSiteData,
  ValidateSiteResponse,
  ValidateSiteError,
  ActivateSiteData,
  ActivateSiteResponse,
  ActivateSiteError,
  DeactivateSiteData,
  DeactivateSiteResponse,
  DeactivateSiteError,
  ShadowSiteData,
  ShadowSiteResponse,
  ShadowSiteError,
  ConfigureSiteData,
  ConfigureSiteResponse,
  ConfigureSiteError,
  UpdateContractConfigurationData,
  UpdateContractConfigurationResponse,
  UpdateContractConfigurationError,
  UpdateRevenueConfigurationData,
  UpdateRevenueConfigurationResponse,
  UpdateRevenueConfigurationError,
  GetSiteConfigurationSchemaData,
  GetSiteConfigurationSchemaResponse,
  GetSiteEnergyData,
  GetSiteEnergyResponse,
  GetSiteEnergyError,
  GetBillingReportData,
  GetBillingReportResponse,
  GetBillingReportError,
  GetAllPartnersInvoicingOverviewData,
  GetAllPartnersInvoicingOverviewResponse,
  GetPartnerInvoicingReportData,
  GetPartnerInvoicingReportResponse,
  GetPartnerInvoicingReportError,
  CreateMqttTokenData,
  CreateMqttTokenResponse,
  CreateMqttTokenError,
  InviteUserData,
  InviteUserResponse,
  InviteUserError,
  ResendUserInviteData,
  ResendUserInviteResponse,
  ResendUserInviteError,
  ListIdentitiesData,
  ListIdentitiesResponse,
  SetIdentityReadOnlyData,
  SetIdentityReadOnlyResponse,
  SetIdentityReadOnlyError,
  DeleteIdentityData,
  DeleteIdentityResponse,
  DeleteIdentityError,
  ClientAuthenticatedData,
  ClientAuthenticatedResponse,
  ClientLoginData,
  ClientLoginResponse,
  ClientLoginError,
  CompleteUserRegistrationData,
  CompleteUserRegistrationResponse,
  CompleteUserRegistrationError,
  AdminLoginAsPartnerData,
  AdminLoginAsPartnerResponse,
  AdminLoginAsDriverData,
  AdminLoginAsDriverResponse,
  RegisterSiteOwnerData,
  RegisterSiteOwnerResponse,
  RegisterSiteOwnerError,
  GetJwksData,
  GetJwksResponse,
  GetOpenidConfigurationData,
  GetOpenidConfigurationResponse,
  ListControllerTokensData,
  ListControllerTokensResponse,
  CreateControllerTokenAsAdminData,
  CreateControllerTokenAsAdminResponse,
  CreateControllerTokenAsAdminError,
  RevokeControllerTokenData,
  RevokeControllerTokenResponse,
  RevokeControllerTokenError,
  CreateControllerImagePullTokenData,
  CreateControllerImagePullTokenResponse,
  GetControllerConfigurationData,
  GetControllerConfigurationResponse,
  SchemaOnlyControllerAdminData,
  SchemaOnlyControllerAdminResponse,
  SchemaOnlyDeviceInfoData,
  SchemaOnlyDeviceInfoError,
  ReportControllerAlertsData,
  ReportControllerAlertsResponse,
  ReportControllerAlertsError,
  ListSiteAlertsData,
  ListSiteAlertsResponse,
  ListSiteAlertsError,
  GetSiteAlertSettingsData,
  GetSiteAlertSettingsResponse,
  GetSiteAlertSettingsError,
  UpdateSiteAlertSettingsData,
  UpdateSiteAlertSettingsResponse,
  UpdateSiteAlertSettingsError,
  ListSiteIoConfigurationsData,
  ListSiteIoConfigurationsResponse,
  GetSiteIoConfigurationData,
  GetSiteIoConfigurationResponse,
  GetSiteIoConfigurationError,
  PatchSiteIoConfigurationData,
  PatchSiteIoConfigurationResponse,
  PatchSiteIoConfigurationError,
  CreateSiteIoConfigurationData,
  CreateSiteIoConfigurationResponse,
  CreateSiteIoConfigurationError,
  GetControllerConfigurationStatusData,
  GetControllerConfigurationStatusResponse,
  GetControllerConfigurationStatusError,
  GetModbusRegisterCatalogData,
  GetModbusRegisterCatalogResponse,
  GetPartnersData,
  GetPartnersResponse,
  CreatePartnerData,
  CreatePartnerResponse,
  CreatePartnerError,
  PartnerRouterDeletePartnerV1PartnerPartnerIdDeleteData,
  PartnerRouterDeletePartnerV1PartnerPartnerIdDeleteError,
  PartnerRouterGetPartnerV1PartnerPartnerIdGetData,
  PartnerRouterGetPartnerV1PartnerPartnerIdGetResponse,
  PartnerRouterGetPartnerV1PartnerPartnerIdGetError,
  PartnerRouterUpdatePartnerV1PartnerPartnerIdPutData,
  PartnerRouterUpdatePartnerV1PartnerPartnerIdPutResponse,
  PartnerRouterUpdatePartnerV1PartnerPartnerIdPutError,
  PartnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPostData,
  PartnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPostResponse,
  PartnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPostError,
  GetPartnerBrandingData,
  GetPartnerBrandingResponse,
  GetPartnerBrandingError,
  GetAggregatedScheduleData,
  GetAggregatedScheduleError,
  GetAggregatedSocScheduleData,
  GetAggregatedSocScheduleError,
  GetEnergyScheduleData,
  GetEnergyScheduleResponse,
  GetEnergyScheduleError,
  GetAssetEnergyScheduleData,
  GetAssetEnergyScheduleResponse,
  GetAssetEnergyScheduleError,
  GetOptimizationResultData,
  GetOptimizationResultResponse,
  GetOptimizationResultError,
  SchemaOnlyAdviceData,
  SchemaOnlyAdviceResponse,
  SchemaOnlyAdviceError,
  SchemaOnlyPoliciesData,
  SchemaOnlyPoliciesResponse,
  GetDayAHeadPricesData,
  GetDayAHeadPricesResponse,
  GetDayAHeadPricesError,
  GetDayAHeadPricesWithForecastData,
  GetDayAHeadPricesWithForecastResponse,
  GetDayAHeadPricesWithForecastError,
  OptimizationsGetTasksData,
  OptimizationsGetTasksResponse,
  OptimizationsGetTasksError,
  OptimizationsDeleteTaskData,
  OptimizationsDeleteTaskError,
  OptimizationsGetTaskData,
  OptimizationsGetTaskResponse,
  OptimizationsGetTaskError,
  OptimizationsCreateTaskData,
  OptimizationsCreateTaskResponse,
  OptimizationsCreateTaskError,
  OptimizationsUpdateTaskData,
  OptimizationsUpdateTaskResponse,
  OptimizationsUpdateTaskError,
  PredictionsGetTasksData,
  PredictionsGetTasksResponse,
  PredictionsGetTasksError,
  PredictionsDeleteTaskData,
  PredictionsDeleteTaskError,
  PredictionsGetTaskData,
  PredictionsGetTaskResponse,
  PredictionsGetTaskError,
  PredictionsCreateTaskData,
  PredictionsCreateTaskResponse,
  PredictionsCreateTaskError,
  PredictionsUpdateTaskData,
  PredictionsUpdateTaskResponse,
  PredictionsUpdateTaskError,
  ForecastingGetTasksData,
  ForecastingGetTasksResponse,
  ForecastingGetTasksError,
  ForecastingDeleteTaskData,
  ForecastingDeleteTaskError,
  ForecastingGetTaskData,
  ForecastingGetTaskResponse,
  ForecastingGetTaskError,
  ForecastingCreateTaskData,
  ForecastingCreateTaskResponse,
  ForecastingCreateTaskError,
  ForecastingUpdateTaskData,
  ForecastingUpdateTaskResponse,
  ForecastingUpdateTaskError,
  GetSiteForecastsData,
  GetSiteForecastsResponse,
  GetSiteForecastsError,
  GetDevicePredictionInsightsInArrowData,
  GetDevicePredictionInsightsInArrowError,
  GetImbalancePriceInsightsData,
  GetImbalancePriceInsightsResponse,
  GetImbalancePriceInsightsError,
  GetImbalanceForecastMetricsData,
  GetImbalanceForecastMetricsResponse,
  GetImbalanceForecastMetricsError,
  CreateForecastingTaskData,
  CreateForecastingTaskError,
  ForecastingGetGlobalTasksData,
  ForecastingGetGlobalTasksResponse,
  ForecastingGetGlobalTasksError,
  ReschedulePendingForecastingTasksData,
  ListProfilesData,
  ListProfilesResponse,
  ListProfilesError,
  CreateProfileData,
  CreateProfileResponse,
  CreateProfileError,
  DeleteProfileData,
  DeleteProfileResponse,
  DeleteProfileError,
  GetProfileData,
  GetProfileResponse,
  GetProfileError,
  PatchProfileData,
  PatchProfileResponse,
  PatchProfileError,
  WebhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPostData,
  WebhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPostResponse,
  WebhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPostError,
  LoginWithPasswordData,
  LoginWithPasswordResponse,
  LoginWithPasswordError,
  StartDriverLoginData,
  StartDriverLoginResponse,
  StartDriverLoginError,
  RequestPasswordResetData,
  RequestPasswordResetResponse,
  RequestPasswordResetError,
  ResetPasswordData,
  ResetPasswordResponse,
  ResetPasswordError,
  GetAuthenticatedDriverData,
  GetAuthenticatedDriverResponse,
  BatchCreateDriversData,
  BatchCreateDriversResponse,
  BatchCreateDriversError,
  GetDriversData,
  GetDriversResponse,
  GetDriversError,
  CreateDriverData,
  CreateDriverResponse,
  CreateDriverError,
  SetDriverProfileData,
  SetDriverProfileResponse,
  SetDriverProfileError,
  SetDriverCarData,
  SetDriverCarResponse,
  SetDriverCarError,
  MarkOnboardingAsSeenData,
  MarkOnboardingAsSeenResponse,
  SetDriverEmailData,
  SetDriverEmailResponse,
  SetDriverEmailError,
  SetDriverEmailNotificationsData,
  SetDriverEmailNotificationsResponse,
  SetDriverEmailNotificationsError,
  SetDriverPasswordData,
  SetDriverPasswordError,
  DeleteDriverData,
  DeleteDriverError,
  GetDriverData,
  GetDriverResponse,
  GetDriverError,
  UpdateDriverData,
  UpdateDriverResponse,
  UpdateDriverError,
  RequestMagicLinkData,
  RequestMagicLinkResponse,
  RequestMagicLinkError,
  VerifyMagicLinkData,
  VerifyMagicLinkResponse,
  VerifyMagicLinkError,
  VerifyMagicLinkTokenData,
  VerifyMagicLinkTokenResponse,
  VerifyMagicLinkTokenError,
  GetDriverActiveTransactionData,
  GetDriverActiveTransactionResponse,
  GetDriverTransactionMeasurementsData,
  GetDriverTransactionMeasurementsResponse,
  SubmitDriverInputData,
  SubmitDriverInputResponse,
  SubmitDriverInputError,
  GetDriverScheduleData,
  GetDriverScheduleResponse,
  GetEvVehicleMakesData,
  GetEvVehicleMakesResponse,
  GetEvVehicleModelsData,
  GetEvVehicleModelsResponse,
  GetEvVehicleModelsError,
  GetEvVehicleVariantsData,
  GetEvVehicleVariantsResponse,
  GetEvVehicleVariantsError,
  GetEvVehicleData,
  GetEvVehicleResponse,
  GetEvVehicleError,
  PxcAdminRouterCreateTokenV1PxcTokensPostData,
  PxcAdminRouterCreateTokenV1PxcTokensPostResponse,
  PxcAdminRouterCreateTokenV1PxcTokensPostError,
  PxcAdminRouterDeleteTokenV1PxcTokensTokenIdDeleteData,
  PxcAdminRouterDeleteTokenV1PxcTokensTokenIdDeleteResponse,
  PxcAdminRouterDeleteTokenV1PxcTokensTokenIdDeleteError,
  GetOcppConfigurationsData,
  GetOcppConfigurationsResponse,
  CreateOcppConfigurationData,
  CreateOcppConfigurationResponse,
  CreateOcppConfigurationError,
  GetOcppActiveSocketsForSiteData,
  GetOcppActiveSocketsForSiteResponse,
  GetOcppActiveSocketsForSiteError,
  GetOcppConfigurationData,
  GetOcppConfigurationResponse,
  GetOcppConfigurationError,
  DeleteOcppConfigurationData,
  DeleteOcppConfigurationError,
  UpdateOcppConfigurationData,
  UpdateOcppConfigurationResponse,
  UpdateOcppConfigurationError,
  UpdateSocketToAssetMapData,
  UpdateSocketToAssetMapResponse,
  UpdateSocketToAssetMapError,
  GetSocketMappingSuggestionsData,
  GetSocketMappingSuggestionsResponse,
  GetSocketMappingSuggestionsError,
  ListOcppMessagesData,
  ListOcppMessagesResponse,
  ListOcppMessagesError,
  DiagnoseOcppTransactionLinkingData,
  DiagnoseOcppTransactionLinkingResponse,
  DiagnoseOcppTransactionLinkingError,
  BenefitReportRouterListReportsV1BenefitReportsSiteIdGetData,
  BenefitReportRouterListReportsV1BenefitReportsSiteIdGetResponse,
  BenefitReportRouterListReportsV1BenefitReportsSiteIdGetError,
  BenefitReportRouterGetReportV1BenefitReportsSiteIdYearMonthGetData,
  BenefitReportRouterGetReportV1BenefitReportsSiteIdYearMonthGetResponse,
  BenefitReportRouterGetReportV1BenefitReportsSiteIdYearMonthGetError,
  AlertSubscriptionRouterListAlertSubscriptionsV1AlertSubscriptionsGetData,
  AlertSubscriptionRouterListAlertSubscriptionsV1AlertSubscriptionsGetResponse,
  AlertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPostData,
  AlertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPostResponse,
  AlertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPostError,
  AlertSubscriptionRouterDeleteAlertSubscriptionV1AlertSubscriptionsIdDeleteData,
  AlertSubscriptionRouterDeleteAlertSubscriptionV1AlertSubscriptionsIdDeleteError,
  AlertSubscriptionRouterGetAlertSubscriptionV1AlertSubscriptionsIdGetData,
  AlertSubscriptionRouterGetAlertSubscriptionV1AlertSubscriptionsIdGetResponse,
  AlertSubscriptionRouterGetAlertSubscriptionV1AlertSubscriptionsIdGetError,
  AlertSubscriptionRouterUpdateAlertSubscriptionV1AlertSubscriptionsIdPutData,
  AlertSubscriptionRouterUpdateAlertSubscriptionV1AlertSubscriptionsIdPutResponse,
  AlertSubscriptionRouterUpdateAlertSubscriptionV1AlertSubscriptionsIdPutError,
  RequestSiteGoLiveData,
  RequestSiteGoLiveResponse,
  RequestSiteGoLiveError,
} from "./types.gen";
import { client as _heyApiClient } from "./client.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Create a new measurement
 * Create a new measurement. If possible consider relying on our MQTT broker to send measurements.
 */
export const createMeasurement = <ThrowOnError extends boolean = false>(
  options: Options<CreateMeasurementData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateMeasurementResponse,
    CreateMeasurementError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/measurement",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Create a new transaction
 * Create a new transaction. If possible consider relying on our MQTT broker to send transactions.
 */
export const createTransaction = <ThrowOnError extends boolean = false>(
  options: Options<CreateTransactionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateTransactionResponse,
    CreateTransactionError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/transaction",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Datarouter.Post Measurements From Mqtt
 */
export const dataRouterPostMeasurementsFromMqttV1DataMqttMeasurementsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DataRouterPostMeasurementsFromMqttV1DataMqttMeasurementsPostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<
    unknown,
    DataRouterPostMeasurementsFromMqttV1DataMqttMeasurementsPostError,
    ThrowOnError
  >({
    url: "/v1/data/mqtt/measurements",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Datarouter.Post Transactions From Mqtt
 */
export const dataRouterPostTransactionsFromMqttV1DataMqttTransactionsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DataRouterPostTransactionsFromMqttV1DataMqttTransactionsPostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<
    unknown,
    DataRouterPostTransactionsFromMqttV1DataMqttTransactionsPostError,
    ThrowOnError
  >({
    url: "/v1/data/mqtt/transactions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Datarouter.Post Transaction Events From Mqtt
 */
export const dataRouterPostTransactionEventsFromMqttV1DataMqttTransactionEventsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DataRouterPostTransactionEventsFromMqttV1DataMqttTransactionEventsPostData,
      ThrowOnError
    >,
  ) => {
    return (options.client ?? _heyApiClient).post<
      unknown,
      DataRouterPostTransactionEventsFromMqttV1DataMqttTransactionEventsPostError,
      ThrowOnError
    >({
      url: "/v1/data/mqtt/transaction-events",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    });
  };

/**
 * Schema-only endpoint exposing the MQTT payloads the controller publishes to the API.
 * Exists solely to surface the payloads the controller publishes over MQTT — MqttMeasurement (to v2/{partner_id}/{site_id}/asset/{asset_id}/energyMeasurement) and ControllerTransactionEvent (to v2/{partner_id}/{site_id}/asset/{asset_id}/transaction-events) — in the OpenAPI schema so that generated clients carry a typed representation of them. They are modelled as the request body because the controller sends them to the API, so breaking changes are detected with the correct polarity. It is not callable at runtime.
 */
export const schemaOnlyControllerMqttPayloads = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SchemaOnlyControllerMqttPayloadsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    unknown,
    SchemaOnlyControllerMqttPayloadsError,
    ThrowOnError
  >({
    url: "/v1/data/_schemas/controller-mqtt-payloads",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Schema-only endpoint exposing the MQTT payloads partners publish to the API.
 * Exists solely to surface the payloads a partner publishes over MQTT — MqttMeasurement (to v2/{partner_id}/{site_id}/asset/{asset_id}/energyMeasurement) and MqttTransaction (to v2/{partner_id}/{site_id}/asset/{asset_id}/transaction) — in the OpenAPI schema so that generated clients carry a typed representation of them. They are modelled as the request body because the partner sends them to the API, so breaking changes are detected with the correct polarity. It is not callable at runtime.
 */
export const schemaOnlyPartnerMqttPayloads = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SchemaOnlyPartnerMqttPayloadsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    unknown,
    SchemaOnlyPartnerMqttPayloadsError,
    ThrowOnError
  >({
    url: "/v1/data/_schemas/partner-mqtt-payloads",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Datarouter.Get Latest Measurements For Site
 */
export const getLatestMeasurementsForSite = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetLatestMeasurementsForSiteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetLatestMeasurementsForSiteResponse,
    GetLatestMeasurementsForSiteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/site/{site_id}/measurements/latest",
    ...options,
  });
};

/**
 * Datarouter.Get Latest Measurement For Site
 */
export const getLatestMeasurementForSite = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetLatestMeasurementForSiteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetLatestMeasurementForSiteResponse,
    GetLatestMeasurementForSiteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/site/{site_id}/measurement/latest",
    ...options,
  });
};

/**
 * Datarouter.Get Latest Transactions For Site
 */
export const getLatestTransactionsForSite = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetLatestTransactionsForSiteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetLatestTransactionsForSiteResponse,
    GetLatestTransactionsForSiteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/site/{site_id}/transactions/latest",
    ...options,
  });
};

/**
 * Datarouter.Get Recent Transactions For Site
 */
export const getRecentTransactionsForSite = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetRecentTransactionsForSiteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetRecentTransactionsForSiteResponse,
    GetRecentTransactionsForSiteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/site/{site_id}/transactions/recent",
    ...options,
  });
};

/**
 * Datarouter.Get Calculated Ucl For Site In Arrow
 */
export const getCalculatedUclForSiteInArrow = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetCalculatedUclForSiteInArrowData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    unknown,
    GetCalculatedUclForSiteInArrowError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/site/{site_id}/calculated-ucl.arrow",
    ...options,
  });
};

/**
 * Datarouter.Get Power Overview For Site In Arrow
 */
export const getPowerOverviewForSiteInArrow = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPowerOverviewForSiteInArrowData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    unknown,
    GetPowerOverviewForSiteInArrowError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/site/{site_id}/power-overview.arrow",
    ...options,
  });
};

/**
 * Datarouter.Get Soc Overview For Site In Arrow
 */
export const getSocOverviewForSiteInArrow = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetSocOverviewForSiteInArrowData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    unknown,
    GetSocOverviewForSiteInArrowError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/site/{site_id}/soc-overview.arrow",
    ...options,
  });
};

/**
 * Datarouter.Get Transaction Stats For Site
 */
export const getTransactionStatsForSite = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetTransactionStatsForSiteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetTransactionStatsForSiteResponse,
    GetTransactionStatsForSiteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/site/{site_id}/transactions/stats",
    ...options,
  });
};

/**
 * Datarouter.Get Driver Summaries For Site
 */
export const getDriverSummariesForSite = <ThrowOnError extends boolean = false>(
  options: Options<GetDriverSummariesForSiteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetDriverSummariesForSiteResponse,
    GetDriverSummariesForSiteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/site/{site_id}/drivers/summary",
    ...options,
  });
};

/**
 * Datarouter.Get Active Transactions With Energy For Site
 */
export const getActiveTransactionsWithEnergyForSite = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetActiveTransactionsWithEnergyForSiteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetActiveTransactionsWithEnergyForSiteResponse,
    GetActiveTransactionsWithEnergyForSiteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/site/{site_id}/active-transactions",
    ...options,
  });
};

/**
 * List active driver sessions across all sites, as admin
 * Lists the most recently started still-active driver sessions across every site, so an admin can pick a driver to log in as for debugging.
 */
export const getActiveDriverSessions = <ThrowOnError extends boolean = false>(
  options?: Options<GetActiveDriverSessionsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetActiveDriverSessionsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/active-driver-sessions",
    ...options,
  });
};

/**
 * Overwrite the driver charging preferences of an active transaction.
 * Lets a partner admin overwrite the requested energy (AC) or target state of charge (DC) and the estimated departure time of an active transaction. This takes precedence over profiles and charge point reported values; between an admin overwrite and driver app input the most recent one wins.
 */
export const overwriteDriverPreferencesForTransaction = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OverwriteDriverPreferencesForTransactionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    OverwriteDriverPreferencesForTransactionResponse,
    OverwriteDriverPreferencesForTransactionError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/site/{site_id}/transaction/{transaction_id}/driver-preferences-overwrite",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * End an active transaction as a ghost transaction, as admin
 * Ends an active transaction that will never receive a stop, the same way the ghost transaction job does. The stop time is the last charging power measurement, capped at five minutes before the next transaction on the same asset if there is one.
 */
export const endTransactionAsGhost = <ThrowOnError extends boolean = false>(
  options: Options<EndTransactionAsGhostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    EndTransactionAsGhostResponse,
    EndTransactionAsGhostError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/site/{site_id}/transaction/{transaction_id}/end-as-ghost",
    ...options,
  });
};

/**
 * Datarouter.Get Latest Measurement For Asset
 */
export const getLatestMeasurementForAsset = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetLatestMeasurementForAssetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetLatestMeasurementForAssetResponse,
    GetLatestMeasurementForAssetError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/site/{site_id}/asset/{asset_id}/measurements/latest",
    ...options,
  });
};

/**
 * Datarouter.Get Measurements For Site
 */
export const getMeasurementsForSite = <ThrowOnError extends boolean = false>(
  options: Options<GetMeasurementsForSiteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GetMeasurementsForSiteResponse,
    GetMeasurementsForSiteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/site/{site_id}/measurements",
    ...options,
  });
};

/**
 * Datarouter.Get Quarterly Measurements For Site
 */
export const getMeasurementsForSiteQuarterHourly = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetMeasurementsForSiteQuarterHourlyData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    unknown,
    GetMeasurementsForSiteQuarterHourlyError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/site/{site_id}/measurements/quarter-hourly",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Datarouter.Get Measurements For Asset
 */
export const getMeasurementsForAsset = <ThrowOnError extends boolean = false>(
  options: Options<GetMeasurementsForAssetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GetMeasurementsForAssetResponse,
    GetMeasurementsForAssetError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/site/{site_id}/{asset_id}/measurements",
    ...options,
  });
};

/**
 * Datarouter.Get Measurements For Site In Arrow
 */
export const getMeasurementsForSiteInArrow = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetMeasurementsForSiteInArrowData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    unknown,
    GetMeasurementsForSiteInArrowError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/site/{site_id}/measurements.arrow",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Datarouter.Get Measurements For Asset In Arrow
 */
export const getMeasurementsForAssetInArrow = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetMeasurementsForAssetInArrowData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    unknown,
    GetMeasurementsForAssetInArrowError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/site/{site_id}/{asset_id}/measurements.arrow",
    ...options,
  });
};

/**
 * Datarouter.Get Measurements For Asset In Arrow Interpolated
 */
export const getMeasurementsForAssetInArrowInterpolated = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetMeasurementsForAssetInArrowInterpolatedData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<
    unknown,
    GetMeasurementsForAssetInArrowInterpolatedError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/site/{site_id}/{asset_id}/measurements-interpolated.arrow",
    ...options,
  });
};

/**
 * Datarouter.Get Transactions With Events For Site
 */
export const getTransactionsWithEventsForSite = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetTransactionsWithEventsForSiteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetTransactionsWithEventsForSiteResponse,
    GetTransactionsWithEventsForSiteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/site/{site_id}/transactions/with-events",
    ...options,
  });
};

/**
 * Datarouter.Get Transactions For Site
 */
export const getTransactionsForSite = <ThrowOnError extends boolean = false>(
  options: Options<GetTransactionsForSiteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetTransactionsForSiteResponse,
    GetTransactionsForSiteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/site/{site_id}/transactions",
    ...options,
  });
};

/**
 * Datarouter.Get Lifecycle Around Active Transactions Before
 */
export const getLifecycleAroundActiveTransactions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetLifecycleAroundActiveTransactionsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetLifecycleAroundActiveTransactionsResponse,
    GetLifecycleAroundActiveTransactionsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/site/{site_id}/transactions/lifecycle",
    ...options,
  });
};

/**
 * Datarouter.List Failed Messages
 */
export const listFailedMessages = <ThrowOnError extends boolean = false>(
  options?: Options<ListFailedMessagesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ListFailedMessagesResponse,
    ListFailedMessagesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/data/failed-messages",
    ...options,
  });
};

/**
 * Get all sites
 * Fetch a list of all existing sites
 */
export const listSites = <ThrowOnError extends boolean = false>(
  options?: Options<ListSitesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ListSitesResponse,
    ListSitesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/",
    ...options,
  });
};

/**
 * Create site
 * Create a new site. In general it's a good idea to first create a site without any configuration and then add the configuration separately. This allows us to validate the site based on measurement data when adding the configuration.
 */
export const createSite = <ThrowOnError extends boolean = false>(
  options: Options<CreateSiteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateSiteResponse,
    CreateSiteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Delete site
 * Remove a site from the system using its site_id. This is not reversible. The measurements and transactions linked to this site wont be deleted. If you afterwards re-create a site with the same site_id it will match with the old measurements and transactions.
 */
export const deleteSite = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSiteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    DeleteSiteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/{site_id}",
    ...options,
  });
};

/**
 * Get site
 * Fetch details of a specific site using its site_id
 */
export const getSite = <ThrowOnError extends boolean = false>(
  options: Options<GetSiteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSiteResponse,
    GetSiteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/{site_id}",
    ...options,
  });
};

/**
 * Patch site
 * Partially update a site by its site_id, modifying only specified fields
 */
export const patchSite = <ThrowOnError extends boolean = false>(
  options: Options<PatchSiteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    PatchSiteResponse,
    PatchSiteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/{site_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Replace site
 * Replace the entire site data by its site_id
 */
export const updateSite = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSiteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateSiteResponse,
    UpdateSiteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/{site_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Validate site
 * Revalidate a site and return the site with the updated validation information.
 */
export const validateSite = <ThrowOnError extends boolean = false>(
  options: Options<ValidateSiteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    ValidateSiteResponse,
    ValidateSiteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/{site_id}/validation",
    ...options,
  });
};

/**
 * Activate site
 * Activate a site
 */
export const activateSite = <ThrowOnError extends boolean = false>(
  options: Options<ActivateSiteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ActivateSiteResponse,
    ActivateSiteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/{site_id}/activate",
    ...options,
  });
};

/**
 * Deactivate site
 * Deactivate a site
 */
export const deactivateSite = <ThrowOnError extends boolean = false>(
  options: Options<DeactivateSiteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    DeactivateSiteResponse,
    DeactivateSiteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/{site_id}/deactivate",
    ...options,
  });
};

/**
 * Put site in shadow mode
 * Put a site in shadow mode: forecasting and optimization keep running but schedules are not sent to the controller
 */
export const shadowSite = <ThrowOnError extends boolean = false>(
  options: Options<ShadowSiteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ShadowSiteResponse,
    ShadowSiteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/{site_id}/shadow",
    ...options,
  });
};

/**
 * Add or update site configuration
 * Add or modify the configuration (both site-configuration and optimization configuration) for a specific site using its site_id. First create a site with a POST call (see above) and then add the configurations.
 */
export const configureSite = <ThrowOnError extends boolean = false>(
  options: Options<ConfigureSiteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    ConfigureSiteResponse,
    ConfigureSiteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/{site_id}/site-configuration",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Update contract configuration
 * Update only the contract configuration for a specific site using its site_id
 */
export const updateContractConfiguration = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateContractConfigurationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateContractConfigurationResponse,
    UpdateContractConfigurationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/{site_id}/configurations/contract",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Update revenue configuration
 * Update only the charging revenue configuration for a specific site using its site_id
 */
export const updateRevenueConfiguration = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateRevenueConfigurationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateRevenueConfigurationResponse,
    UpdateRevenueConfigurationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/{site_id}/configurations/revenue",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get site_configuration schema
 * Get the schema for the site_configuration
 */
export const getSiteConfigurationSchema = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetSiteConfigurationSchemaData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetSiteConfigurationSchemaResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/schema/site_configuration",
    ...options,
  });
};

/**
 * Siteinsightsrouter.Get Site Energy
 */
export const getSiteEnergy = <ThrowOnError extends boolean = false>(
  options: Options<GetSiteEnergyData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSiteEnergyResponse,
    GetSiteEnergyError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/insights/sites/{site_id}/energy",
    ...options,
  });
};

/**
 * Get billing report
 */
export const getBillingReport = <ThrowOnError extends boolean = false>(
  options: Options<GetBillingReportData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetBillingReportResponse,
    GetBillingReportError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/billing/report/{partner_id}",
    ...options,
  });
};

/**
 * Get invoicing overview aggregated across all partners
 */
export const getAllPartnersInvoicingOverview = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAllPartnersInvoicingOverviewData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAllPartnersInvoicingOverviewResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/invoicing/overview",
    ...options,
  });
};

/**
 * Get invoicing report for a single partner
 */
export const getPartnerInvoicingReport = <ThrowOnError extends boolean = false>(
  options: Options<GetPartnerInvoicingReportData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetPartnerInvoicingReportResponse,
    GetPartnerInvoicingReportError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/invoicing/report/{partner_id}",
    ...options,
  });
};

/**
 * Mint MQTT access token
 * Issue a short-lived JWT scoped to a single site that can be used to authenticate against the MQTT broker.
 */
export const createMqttToken = <ThrowOnError extends boolean = false>(
  options: Options<CreateMqttTokenData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateMqttTokenResponse,
    CreateMqttTokenError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/mqtt/token",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Invite a new user as admin, partner or site owner.
 * Create a pending identity and email it a link to set its password. Admins may invite for any partner and may invite admins. Partners may only invite for their own partner, and only users or site owners for sites they own.
 */
export const inviteUser = <ThrowOnError extends boolean = false>(
  options: Options<InviteUserData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    InviteUserResponse,
    InviteUserError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/identity/user/invite",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Resend a user invitation
 * Invalidate the current one-time invite token, issue a new one, and resend the invitation email. Partners may only resend invites for identities that belong to their own partner.
 */
export const resendUserInvite = <ThrowOnError extends boolean = false>(
  options: Options<ResendUserInviteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ResendUserInviteResponse,
    ResendUserInviteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/identity/user/{identity_id}/resend-invite",
    ...options,
  });
};

/**
 * List identities
 * List every registered identity without their credentials. Admins see identities across every partner; partners only see their own.
 */
export const listIdentities = <ThrowOnError extends boolean = false>(
  options?: Options<ListIdentitiesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ListIdentitiesResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/identity/",
    ...options,
  });
};

/**
 * Set an identity's read-only access
 * Change whether an identity has read-only (viewer) access after it has already been created. Admins may update any identity. Partners may only update identities that belong to their own partner. Neither may change their own read-only status.
 */
export const setIdentityReadOnly = <ThrowOnError extends boolean = false>(
  options: Options<SetIdentityReadOnlyData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    SetIdentityReadOnlyResponse,
    SetIdentityReadOnlyError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/identity/{identity_id}/read-only",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Delete an identity
 * Delete an identity. Admins may delete any identity, including other admins. Partners may only delete site owners that belong to their own partner.
 */
export const deleteIdentity = <ThrowOnError extends boolean = false>(
  options: Options<DeleteIdentityData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteIdentityResponse,
    DeleteIdentityError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/identity/{identity_id}",
    ...options,
  });
};

/**
 * Check if a client is authenticated
 * Check if a client is authenticated using a token.
 */
export const clientAuthenticated = <ThrowOnError extends boolean = false>(
  options?: Options<ClientAuthenticatedData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ClientAuthenticatedResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/identity/client-login",
    ...options,
  });
};

/**
 * Get OAuth2 access token
 * Authenticate a client using basic credentials to obtain an OAuth2 access token.
 */
export const clientLogin = <ThrowOnError extends boolean = false>(
  options?: Options<ClientLoginData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    ClientLoginResponse,
    ClientLoginError,
    ThrowOnError
  >({
    ...urlSearchParamsBodySerializer,
    security: [
      {
        scheme: "basic",
        type: "http",
      },
    ],
    url: "/v1/identity/client-login",
    ...options,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      ...options?.headers,
    },
  });
};

/**
 * Complete a user registration
 * Redeem a one-time invite token and set the account's password.
 */
export const completeUserRegistration = <ThrowOnError extends boolean = false>(
  options: Options<CompleteUserRegistrationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CompleteUserRegistrationResponse,
    CompleteUserRegistrationError,
    ThrowOnError
  >({
    url: "/v1/identity/user/complete-registration",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get OAuth2 access token for partner, as admin
 * Get an access token to access the partner dashboard as an admin
 */
export const adminLoginAsPartner = <ThrowOnError extends boolean = false>(
  options?: Options<AdminLoginAsPartnerData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    AdminLoginAsPartnerResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/identity/login-as-partner",
    ...options,
  });
};

/**
 * Get an access token for a driver, as admin
 * Get an access token to access the driver app as an admin, for debugging
 */
export const adminLoginAsDriver = <ThrowOnError extends boolean = false>(
  options?: Options<AdminLoginAsDriverData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    AdminLoginAsDriverResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/identity/login-as-driver",
    ...options,
  });
};

/**
 * Register a new site owner
 */
export const registerSiteOwner = <ThrowOnError extends boolean = false>(
  options: Options<RegisterSiteOwnerData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    RegisterSiteOwnerResponse,
    RegisterSiteOwnerError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/identity/site-owner/register",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * JWKS
 * Public JSON Web Key Set used to verify tokens issued by the identity service.
 */
export const getJwks = <ThrowOnError extends boolean = false>(
  options?: Options<GetJwksData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetJwksResponse,
    unknown,
    ThrowOnError
  >({
    url: "/.well-known/jwks.json",
    ...options,
  });
};

/**
 * OpenID provider metadata
 * Discovery document that lets OIDC relying parties such as Google Cloud workload identity federation find the JWKS.
 */
export const getOpenidConfiguration = <ThrowOnError extends boolean = false>(
  options?: Options<GetOpenidConfigurationData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOpenidConfigurationResponse,
    unknown,
    ThrowOnError
  >({
    url: "/.well-known/openid-configuration",
    ...options,
  });
};

/**
 * List controller tokens
 */
export const listControllerTokens = <ThrowOnError extends boolean = false>(
  options?: Options<ListControllerTokensData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ListControllerTokensResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/controller-tokens/",
    ...options,
  });
};

/**
 * Create a non-expiring controller token for any partner
 * Creates a non-expiring JWT for a local controller on behalf of any partner. The returned access_token is shown only once and must be hard-coded into the device. Revoke via DELETE using the jti.
 */
export const createControllerTokenAsAdmin = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateControllerTokenAsAdminData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateControllerTokenAsAdminResponse,
    CreateControllerTokenAsAdminError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/controller-tokens/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Revoke a controller token by jti
 */
export const revokeControllerToken = <ThrowOnError extends boolean = false>(
  options: Options<RevokeControllerTokenData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    RevokeControllerTokenResponse,
    RevokeControllerTokenError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/controller-tokens/{jti}",
    ...options,
  });
};

/**
 * Mint controller image pull token
 * Issues a short-lived OIDC token for the calling controller, or for an admin bootstrapping one, that Google Cloud workload identity federation exchanges for an access token to pull the local-controller images.
 */
export const createControllerImagePullToken = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<CreateControllerImagePullTokenData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    CreateControllerImagePullTokenResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/workload-identity/controller-image-pull-token",
    ...options,
  });
};

/**
 * Get the IO configuration for the authenticated controller's site
 * Returns the site IO configuration for the controller identified by the long-lived JWT presented in the Authorization header. The site_id is derived from the token.
 */
export const getControllerConfiguration = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetControllerConfigurationData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetControllerConfigurationResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/controller/configuration/",
    ...options,
  });
};

/**
 * Schema-only endpoint exposing the controller admin-API contract.
 * Exists solely to surface the controller admin-API types in the OpenAPI schema so generated clients carry a typed representation of the contract the controller-proxy speaks to a controller's admin API. The direction is reversed relative to the real call: the controller receives SetLogLevelRequest, modelled here as the response, so breaking changes are detected with the correct polarity. The controller's responses are streamed through untyped and so have nothing to model. It is not callable at runtime.
 */
export const schemaOnlyControllerAdmin = <ThrowOnError extends boolean = false>(
  options?: Options<SchemaOnlyControllerAdminData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    SchemaOnlyControllerAdminResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/controller/configuration/_schemas/controller-admin",
    ...options,
  });
};

/**
 * Schema-only endpoint exposing the controller enrollment payload.
 * Exists solely to surface the device enrollment types in the OpenAPI schema so the controller's generated client carries a typed DeviceInfo matching what the pleevi-licensing backend accepts. The controller produces DeviceInfo (modelled here as the request body), so breaking changes are detected with the correct polarity. It is not callable at runtime.
 */
export const schemaOnlyDeviceInfo = <ThrowOnError extends boolean = false>(
  options: Options<SchemaOnlyDeviceInfoData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    unknown,
    SchemaOnlyDeviceInfoError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/controller/configuration/_schemas/device-info",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Report the alerts the authenticated controller is raising
 * Receives the alert notifications the controller's own Alertmanager sends, as an Alertmanager webhook payload. The site and controller are derived from the long-lived JWT presented in the Authorization header. A firing alert that is already known is updated; a resolved one closes the alert it belongs to.
 */
export const reportControllerAlerts = <ThrowOnError extends boolean = false>(
  options: Options<ReportControllerAlertsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ReportControllerAlertsResponse,
    ReportControllerAlertsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/controller/alerts/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * List the alerts the site's controller raised
 * Fetch the alerts the site's controller reported, the most recently started first. Alerts stay listed after they are resolved, so the list doubles as the site's alert history. Every alert is recorded, but only the ones the site is subscribed to by its alert settings are listed, unless an admin asks.
 */
export const listSiteAlerts = <ThrowOnError extends boolean = false>(
  options: Options<ListSiteAlertsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    ListSiteAlertsResponse,
    ListSiteAlertsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/{site_id}/alerts/",
    ...options,
  });
};

/**
 * Get the alert settings of a site
 * Fetch which alerts, and for which devices, the site is notified of, and the thresholds and durations the site's controller raises its alerts with. A site that has never had them changed is served the defaults.
 */
export const getSiteAlertSettings = <ThrowOnError extends boolean = false>(
  options: Options<GetSiteAlertSettingsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSiteAlertSettingsResponse,
    GetSiteAlertSettingsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/{site_id}/alert-settings/",
    ...options,
  });
};

/**
 * Update the alert settings of a site
 * Replace which alerts, and for which devices, the site is notified of, and the thresholds and durations the site's controller raises its alerts with. Every alert is raised and recorded whether the site is subscribed to it or not. The controller applies the thresholds and durations the next time it reloads its configuration.
 */
export const updateSiteAlertSettings = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSiteAlertSettingsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateSiteAlertSettingsResponse,
    UpdateSiteAlertSettingsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/{site_id}/alert-settings/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * List all site IO configurations
 * Returns every persisted SiteIOConfiguration document across all sites and partners.
 */
export const listSiteIoConfigurations = <ThrowOnError extends boolean = false>(
  options?: Options<ListSiteIoConfigurationsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ListSiteIoConfigurationsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/admin/site-io-configurations/",
    ...options,
  });
};

/**
 * Get the site IO configuration for a site
 * Returns the persisted SiteIOConfiguration document for the given site. Returns 404 if no configuration exists.
 */
export const getSiteIoConfiguration = <ThrowOnError extends boolean = false>(
  options: Options<GetSiteIoConfigurationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSiteIoConfigurationResponse,
    GetSiteIoConfigurationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/admin/site-io-configurations/{site_id}",
    ...options,
  });
};

/**
 * Patch the site IO configuration for a site
 * Partially updates the site IO configuration for the given site. Returns 404 if no configuration exists. site_id and partner_id cannot be changed.
 */
export const patchSiteIoConfiguration = <ThrowOnError extends boolean = false>(
  options: Options<PatchSiteIoConfigurationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    PatchSiteIoConfigurationResponse,
    PatchSiteIoConfigurationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/admin/site-io-configurations/{site_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Create the site IO configuration for a site
 * Creates the site IO configuration for the given site. Returns 409 if a configuration already exists for the site.
 */
export const createSiteIoConfiguration = <ThrowOnError extends boolean = false>(
  options: Options<CreateSiteIoConfigurationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateSiteIoConfigurationResponse,
    CreateSiteIoConfigurationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/admin/site-io-configurations/{site_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get the controller configuration a site's controller would be served
 * Runs the same build the controller's own `getControllerConfiguration` call runs, for the given site instead of the calling controller. Returns the configuration when it can be built, and otherwise every reason it cannot, so a failing controller fetch can be diagnosed from the dashboard. Returns 404 if the site does not exist.
 */
export const getControllerConfigurationStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetControllerConfigurationStatusData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetControllerConfigurationStatusResponse,
    GetControllerConfigurationStatusError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/admin/site-io-configurations/{site_id}/controller-configuration",
    ...options,
  });
};

/**
 * Get the device-identity to Modbus-register-driver mapping
 * Returns the Modbus register driver each supported device is read with, keyed by the device's identity: '<device_type>|<brand>|<model>'. An identity absent from the map is read with 'unsupported'. The register driver is derived from this map on the backend; the dashboard looks an identity up in it to know which register config a selected device needs.
 */
export const getModbusRegisterCatalog = <ThrowOnError extends boolean = false>(
  options?: Options<GetModbusRegisterCatalogData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetModbusRegisterCatalogResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/modbus-register-catalog",
    ...options,
  });
};

/**
 * Partnerrouter.Get Partners
 */
export const getPartners = <ThrowOnError extends boolean = false>(
  options?: Options<GetPartnersData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetPartnersResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/partner/",
    ...options,
  });
};

/**
 * Partnerrouter.Create Partner
 */
export const createPartner = <ThrowOnError extends boolean = false>(
  options: Options<CreatePartnerData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreatePartnerResponse,
    CreatePartnerError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/partner/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Partnerrouter.Delete Partner
 */
export const partnerRouterDeletePartnerV1PartnerPartnerIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PartnerRouterDeletePartnerV1PartnerPartnerIdDeleteData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    PartnerRouterDeletePartnerV1PartnerPartnerIdDeleteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/partner/{partner_id}",
    ...options,
  });
};

/**
 * Partnerrouter.Get Partner
 */
export const partnerRouterGetPartnerV1PartnerPartnerIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PartnerRouterGetPartnerV1PartnerPartnerIdGetData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).get<
    PartnerRouterGetPartnerV1PartnerPartnerIdGetResponse,
    PartnerRouterGetPartnerV1PartnerPartnerIdGetError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/partner/{partner_id}",
    ...options,
  });
};

/**
 * Partnerrouter.Update Partner
 */
export const partnerRouterUpdatePartnerV1PartnerPartnerIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PartnerRouterUpdatePartnerV1PartnerPartnerIdPutData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).put<
    PartnerRouterUpdatePartnerV1PartnerPartnerIdPutResponse,
    PartnerRouterUpdatePartnerV1PartnerPartnerIdPutError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/partner/{partner_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Partnerrouter.Add Partner Connection
 */
export const partnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      PartnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPostData,
      ThrowOnError
    >,
  ) => {
    return (options.client ?? _heyApiClient).post<
      PartnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPostResponse,
      PartnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPostError,
      ThrowOnError
    >({
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/v1/partner/{partner_id}/connection",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    });
  };

/**
 * Get Branding
 */
export const getPartnerBranding = <ThrowOnError extends boolean = false>(
  options: Options<GetPartnerBrandingData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetPartnerBrandingResponse,
    GetPartnerBrandingError,
    ThrowOnError
  >({
    url: "/v1/partner/{partner_id}/branding",
    ...options,
  });
};

/**
 * Retrieve the latest site schedule as an aggregated power time series.
 * Returns the most recent schedule's power profile for [start, stop) as an Apache Arrow stream. The table has a timestamp column, a summed total_power_value column, and one power column per asset. The setpoint already active at start (the most recent one at or before it) is included so the series has no gap at the start of the window.
 */
export const getAggregatedSchedule = <ThrowOnError extends boolean = false>(
  options: Options<GetAggregatedScheduleData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    unknown,
    GetAggregatedScheduleError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/planning/sites/{site_id}/schedule-series",
    ...options,
  });
};

/**
 * Retrieve the latest site schedule as a planned state-of-charge time series.
 * Returns the most recent schedule's planned state-of-charge profile for [start, stop) as an Apache Arrow stream. The table has a timestamp column and one percent-SOC column per BESS asset. The setpoint already active at start (the most recent one at or before it) is included so the series has no gap at the start of the window.
 */
export const getAggregatedSocSchedule = <ThrowOnError extends boolean = false>(
  options: Options<GetAggregatedSocScheduleData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    unknown,
    GetAggregatedSocScheduleError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/planning/sites/{site_id}/soc-schedule-series",
    ...options,
  });
};

/**
 * Retrieve the optimized energy schedule for a site at a specific time.
 * If at_time is not provided, the latest schedule will be returned. If no schedule is found, an empty schedule will be returned.
 */
export const getEnergySchedule = <ThrowOnError extends boolean = false>(
  options: Options<GetEnergyScheduleData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetEnergyScheduleResponse,
    GetEnergyScheduleError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/planning/{site_id}/{at_time}",
    ...options,
  });
};

/**
 * Retrieve the optimized energy schedule for a specific asset in a site.
 * If at_time is not provided, the latest schedule will be returned. If no schedule is found, an empty schedule will be returned.
 */
export const getAssetEnergySchedule = <ThrowOnError extends boolean = false>(
  options: Options<GetAssetEnergyScheduleData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetAssetEnergyScheduleResponse,
    GetAssetEnergyScheduleError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/planning/{site_id}/assets/{asset_id}/{at_time}",
    ...options,
  });
};

/**
 * Retrieve the result of an optimization task.
 * Retrieve the result of an optimization task.
 */
export const getOptimizationResult = <ThrowOnError extends boolean = false>(
  options: Options<GetOptimizationResultData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetOptimizationResultResponse,
    GetOptimizationResultError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/planning/{id}",
    ...options,
  });
};

/**
 * Schema-only endpoint exposing the MQTT advice payload.
 * This endpoint exists solely to surface Advice in the OpenAPI schema so that generated clients carry a typed representation of the payload published over MQTT to v2/{partner_id}/{site_id}/asset/{asset_id}/advice. The payload is both the request body and the response so a field can be neither added nor removed without the diff reporting it. It is not callable at runtime.
 */
export const schemaOnlyAdvice = <ThrowOnError extends boolean = false>(
  options: Options<SchemaOnlyAdviceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SchemaOnlyAdviceResponse,
    SchemaOnlyAdviceError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/planning/_schemas/advice",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Schema-only endpoint exposing the MQTT policy payloads.
 * This endpoint exists solely to surface the policies in the OpenAPI schema so that generated clients carry a typed representation of the payload published over MQTT to v2/{partner_id}/{site_id}/asset/{asset_id}/policy. It is modelled as the response because we publish them to the controller, so adding fields to a policy reads as the compatible change it is while dropping a field is caught. It is not callable at runtime.
 */
export const schemaOnlyPolicies = <ThrowOnError extends boolean = false>(
  options?: Options<SchemaOnlyPoliciesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    SchemaOnlyPoliciesResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/planning/_schemas/policies",
    ...options,
  });
};

/**
 * Get Day-Ahead Prices
 * Retrieve day-ahead prices for a specific bidding zone at a given time.
 */
export const getDayAHeadPrices = <ThrowOnError extends boolean = false>(
  options: Options<GetDayAHeadPricesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetDayAHeadPricesResponse,
    GetDayAHeadPricesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/day_a_head_prices/",
    ...options,
  });
};

/**
 * Get Day-Ahead Prices With Forecast
 * Retrieve day-ahead prices for a specific bidding zone at a given time, split into the prices published by ENTSO-E and the prices our own model forecasted for the same window. The forecast is only returned to admins.
 */
export const getDayAHeadPricesWithForecast = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetDayAHeadPricesWithForecastData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetDayAHeadPricesWithForecastResponse,
    GetDayAHeadPricesWithForecastError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/day_a_head_prices/with_forecast",
    ...options,
  });
};

/**
 * Get Tasks
 * Retrieve a list of tasks based on an optional query.
 */
export const optimizationsGetTasks = <ThrowOnError extends boolean = false>(
  options: Options<OptimizationsGetTasksData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    OptimizationsGetTasksResponse,
    OptimizationsGetTasksError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/optimizations/scheduler/tasks/{site_id}",
    ...options,
  });
};

/**
 * Delete Task
 * Delete a task by ID.
 */
export const optimizationsDeleteTask = <ThrowOnError extends boolean = false>(
  options: Options<OptimizationsDeleteTaskData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    OptimizationsDeleteTaskError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/optimizations/scheduler/task/{id}",
    ...options,
  });
};

/**
 * Get Task
 * Retrieve a single task by ID.
 */
export const optimizationsGetTask = <ThrowOnError extends boolean = false>(
  options: Options<OptimizationsGetTaskData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    OptimizationsGetTaskResponse,
    OptimizationsGetTaskError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/optimizations/scheduler/task/{id}",
    ...options,
  });
};

/**
 * Create Task
 * Create a new task.
 */
export const optimizationsCreateTask = <ThrowOnError extends boolean = false>(
  options: Options<OptimizationsCreateTaskData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    OptimizationsCreateTaskResponse,
    OptimizationsCreateTaskError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/optimizations/scheduler/task",
    ...options,
  });
};

/**
 * Update Task
 * Update an existing task.
 */
export const optimizationsUpdateTask = <ThrowOnError extends boolean = false>(
  options: Options<OptimizationsUpdateTaskData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    OptimizationsUpdateTaskResponse,
    OptimizationsUpdateTaskError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/optimizations/scheduler/task/{task_id}",
    ...options,
  });
};

/**
 * Get Tasks
 * Retrieve a list of tasks based on an optional query.
 */
export const predictionsGetTasks = <ThrowOnError extends boolean = false>(
  options: Options<PredictionsGetTasksData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    PredictionsGetTasksResponse,
    PredictionsGetTasksError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/predictions/scheduler/tasks/{site_id}",
    ...options,
  });
};

/**
 * Delete Task
 * Delete a task by ID.
 */
export const predictionsDeleteTask = <ThrowOnError extends boolean = false>(
  options: Options<PredictionsDeleteTaskData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    PredictionsDeleteTaskError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/predictions/scheduler/task/{id}",
    ...options,
  });
};

/**
 * Get Task
 * Retrieve a single task by ID.
 */
export const predictionsGetTask = <ThrowOnError extends boolean = false>(
  options: Options<PredictionsGetTaskData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    PredictionsGetTaskResponse,
    PredictionsGetTaskError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/predictions/scheduler/task/{id}",
    ...options,
  });
};

/**
 * Create Task
 * Create a new task.
 */
export const predictionsCreateTask = <ThrowOnError extends boolean = false>(
  options: Options<PredictionsCreateTaskData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PredictionsCreateTaskResponse,
    PredictionsCreateTaskError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/predictions/scheduler/task",
    ...options,
  });
};

/**
 * Update Task
 * Update an existing task.
 */
export const predictionsUpdateTask = <ThrowOnError extends boolean = false>(
  options: Options<PredictionsUpdateTaskData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    PredictionsUpdateTaskResponse,
    PredictionsUpdateTaskError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/predictions/scheduler/task/{task_id}",
    ...options,
  });
};

/**
 * Get Tasks
 * Retrieve a list of tasks based on an optional query.
 */
export const forecastingGetTasks = <ThrowOnError extends boolean = false>(
  options: Options<ForecastingGetTasksData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    ForecastingGetTasksResponse,
    ForecastingGetTasksError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/forecasting/scheduler/tasks/{site_id}",
    ...options,
  });
};

/**
 * Delete Task
 * Delete a task by ID.
 */
export const forecastingDeleteTask = <ThrowOnError extends boolean = false>(
  options: Options<ForecastingDeleteTaskData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    ForecastingDeleteTaskError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/forecasting/scheduler/task/{id}",
    ...options,
  });
};

/**
 * Get Task
 * Retrieve a single task by ID.
 */
export const forecastingGetTask = <ThrowOnError extends boolean = false>(
  options: Options<ForecastingGetTaskData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    ForecastingGetTaskResponse,
    ForecastingGetTaskError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/forecasting/scheduler/task/{id}",
    ...options,
  });
};

/**
 * Create Task
 * Create a new task.
 */
export const forecastingCreateTask = <ThrowOnError extends boolean = false>(
  options: Options<ForecastingCreateTaskData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ForecastingCreateTaskResponse,
    ForecastingCreateTaskError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/forecasting/scheduler/task",
    ...options,
  });
};

/**
 * Update Task
 * Update an existing task.
 */
export const forecastingUpdateTask = <ThrowOnError extends boolean = false>(
  options: Options<ForecastingUpdateTaskData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    ForecastingUpdateTaskResponse,
    ForecastingUpdateTaskError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/forecasting/scheduler/task/{task_id}",
    ...options,
  });
};

/**
 * Forecastingrouter.Get Site Forecasts
 */
export const getSiteForecasts = <ThrowOnError extends boolean = false>(
  options: Options<GetSiteForecastsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSiteForecastsResponse,
    GetSiteForecastsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/forecasting/site/{site_id}/predictions",
    ...options,
  });
};

/**
 * Forecastingrouter.Get Device Prediction Insights In Arrow
 */
export const getDevicePredictionInsightsInArrow = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetDevicePredictionInsightsInArrowData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    unknown,
    GetDevicePredictionInsightsInArrowError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/forecasting/site/{site_id}/device/{device_id}/prediction-insights.arrow",
    ...options,
  });
};

/**
 * Forecastingrouter.Get Imbalance Price Insights
 */
export const getImbalancePriceInsights = <ThrowOnError extends boolean = false>(
  options: Options<GetImbalancePriceInsightsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetImbalancePriceInsightsResponse,
    GetImbalancePriceInsightsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/forecasting/imbalance-price/insights",
    ...options,
  });
};

/**
 * Forecastingrouter.Get Imbalance Forecast Metrics
 * Daily value and error metrics of the imbalance forecasters (Brussels days, both inclusive) with monthly
 * and last-30-day aggregates, bootstrap intervals against the free-data baseline and version markers.
 */
export const getImbalanceForecastMetrics = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetImbalanceForecastMetricsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetImbalanceForecastMetricsResponse,
    GetImbalanceForecastMetricsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/forecasting/imbalance-price/forecast-metrics",
    ...options,
  });
};

/**
 * Forecastingrouter.Create Forecasting Task
 */
export const createForecastingTask = <ThrowOnError extends boolean = false>(
  options: Options<CreateForecastingTaskData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    unknown,
    CreateForecastingTaskError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/forecasting/task",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Forecastingrouter.Get Global Tasks
 */
export const forecastingGetGlobalTasks = <ThrowOnError extends boolean = false>(
  options: Options<ForecastingGetGlobalTasksData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    ForecastingGetGlobalTasksResponse,
    ForecastingGetGlobalTasksError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/forecasting/global-tasks/{kind}",
    ...options,
  });
};

/**
 * Forecastingrouter.Reschedule Pending Tasks
 */
export const reschedulePendingForecastingTasks = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ReschedulePendingForecastingTasksData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/forecasting/reschedule-pending-tasks",
    ...options,
  });
};

/**
 * List profiles
 * Fetch a paginated list of profiles. For more information, see the Guide on profiles.
 */
export const listProfiles = <ThrowOnError extends boolean = false>(
  options: Options<ListProfilesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    ListProfilesResponse,
    ListProfilesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/{site_id}/profiles/",
    ...options,
  });
};

/**
 * Create profile
 * Create a new profile. Profiles are used to configure default values for a transaction. For example, you can set a default requested max energy or a default estimated departure time. For more information, see the Guide on profiles.
 */
export const createProfile = <ThrowOnError extends boolean = false>(
  options: Options<CreateProfileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateProfileResponse,
    CreateProfileError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/{site_id}/profiles/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Delete profile
 * Remove a profile by its profile_id (irreversible). For more information, see the Guide on profiles.
 */
export const deleteProfile = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProfileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteProfileResponse,
    DeleteProfileError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/{site_id}/profiles/{profile_id}/",
    ...options,
  });
};

/**
 * Get profile
 * Fetch details of a specific profile by its profile_id. For more information, see the Guide on profiles.
 */
export const getProfile = <ThrowOnError extends boolean = false>(
  options: Options<GetProfileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetProfileResponse,
    GetProfileError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/{site_id}/profiles/{profile_id}/",
    ...options,
  });
};

/**
 * Update profile
 * Partially update a profile by its profile_id. For more information, see the Guide on profiles.
 */
export const patchProfile = <ThrowOnError extends boolean = false>(
  options: Options<PatchProfileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    PatchProfileResponse,
    PatchProfileError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/{site_id}/profiles/{profile_id}/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Webhookrouter.Receive Teleport Webhook
 */
export const webhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    WebhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPostData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).post<
    WebhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPostResponse,
    WebhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPostError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/with-the-grid/callback",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Driverrouter.Login With Password
 */
export const loginWithPassword = <ThrowOnError extends boolean = false>(
  options: Options<LoginWithPasswordData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    LoginWithPasswordResponse,
    LoginWithPasswordError,
    ThrowOnError
  >({
    url: "/v1/drivers/auth/login",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Driverrouter.Start Driver Login
 */
export const startDriverLogin = <ThrowOnError extends boolean = false>(
  options: Options<StartDriverLoginData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    StartDriverLoginResponse,
    StartDriverLoginError,
    ThrowOnError
  >({
    url: "/v1/drivers/auth/login/start",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Driverrouter.Request Password Reset
 */
export const requestPasswordReset = <ThrowOnError extends boolean = false>(
  options: Options<RequestPasswordResetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    RequestPasswordResetResponse,
    RequestPasswordResetError,
    ThrowOnError
  >({
    url: "/v1/drivers/auth/reset-request",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Driverrouter.Reset Password
 */
export const resetPassword = <ThrowOnError extends boolean = false>(
  options: Options<ResetPasswordData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ResetPasswordResponse,
    ResetPasswordError,
    ThrowOnError
  >({
    url: "/v1/drivers/auth/reset",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Driverrouter.Get Authenticated Driver
 */
export const getAuthenticatedDriver = <ThrowOnError extends boolean = false>(
  options?: Options<GetAuthenticatedDriverData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAuthenticatedDriverResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/drivers/me",
    ...options,
  });
};

/**
 * Driverrouter.Batch Create Drivers
 */
export const batchCreateDrivers = <ThrowOnError extends boolean = false>(
  options: Options<BatchCreateDriversData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    BatchCreateDriversResponse,
    BatchCreateDriversError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/drivers/batch",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Driverrouter.Get Drivers
 */
export const getDrivers = <ThrowOnError extends boolean = false>(
  options?: Options<GetDriversData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetDriversResponse,
    GetDriversError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/drivers/",
    ...options,
  });
};

/**
 * Driverrouter.Create Driver
 */
export const createDriver = <ThrowOnError extends boolean = false>(
  options: Options<CreateDriverData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateDriverResponse,
    CreateDriverError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/drivers/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Driverrouter.Set Driver Profile
 */
export const setDriverProfile = <ThrowOnError extends boolean = false>(
  options: Options<SetDriverProfileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    SetDriverProfileResponse,
    SetDriverProfileError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/drivers/me/profile",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Driverrouter.Set Driver Car
 */
export const setDriverCar = <ThrowOnError extends boolean = false>(
  options: Options<SetDriverCarData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    SetDriverCarResponse,
    SetDriverCarError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/drivers/me/car",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Driverrouter.Mark Onboarding As Seen
 */
export const markOnboardingAsSeen = <ThrowOnError extends boolean = false>(
  options?: Options<MarkOnboardingAsSeenData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).put<
    MarkOnboardingAsSeenResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/drivers/me/onboarding-seen",
    ...options,
  });
};

/**
 * Driverrouter.Set Driver Email
 */
export const setDriverEmail = <ThrowOnError extends boolean = false>(
  options: Options<SetDriverEmailData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    SetDriverEmailResponse,
    SetDriverEmailError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/drivers/me/email",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Driverrouter.Set Driver Email Notifications
 */
export const setDriverEmailNotifications = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SetDriverEmailNotificationsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    SetDriverEmailNotificationsResponse,
    SetDriverEmailNotificationsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/drivers/me/email-notifications",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Driverrouter.Set Driver Password
 */
export const setDriverPassword = <ThrowOnError extends boolean = false>(
  options: Options<SetDriverPasswordData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    unknown,
    SetDriverPasswordError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/drivers/me/password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Driverrouter.Delete Driver
 */
export const deleteDriver = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDriverData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    DeleteDriverError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/drivers/{driver_id}",
    ...options,
  });
};

/**
 * Driverrouter.Get Driver
 */
export const getDriver = <ThrowOnError extends boolean = false>(
  options: Options<GetDriverData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetDriverResponse,
    GetDriverError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/drivers/{driver_id}",
    ...options,
  });
};

/**
 * Driverrouter.Update Driver
 */
export const updateDriver = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDriverData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateDriverResponse,
    UpdateDriverError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/drivers/{driver_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Magiclinkrouter.Request Magic Link
 */
export const requestMagicLink = <ThrowOnError extends boolean = false>(
  options: Options<RequestMagicLinkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    RequestMagicLinkResponse,
    RequestMagicLinkError,
    ThrowOnError
  >({
    url: "/v1/auth/magic-link/request",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Magiclinkrouter.Verify Magic Link
 */
export const verifyMagicLink = <ThrowOnError extends boolean = false>(
  options: Options<VerifyMagicLinkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    VerifyMagicLinkResponse,
    VerifyMagicLinkError,
    ThrowOnError
  >({
    url: "/v1/auth/magic-link/verify",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Magiclinkrouter.Verify Magic Link Token
 */
export const verifyMagicLinkToken = <ThrowOnError extends boolean = false>(
  options: Options<VerifyMagicLinkTokenData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    VerifyMagicLinkTokenResponse,
    VerifyMagicLinkTokenError,
    ThrowOnError
  >({
    url: "/v1/auth/magic-link/verify-link",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Retrieve the active transaction and charged energy for the authenticated driver.
 * Returns an object containing the currently active transaction for the driver and the amount of energy charged (if available). Requires driver authentication.
 */
export const getDriverActiveTransaction = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetDriverActiveTransactionData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetDriverActiveTransactionResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/driver/transaction",
    ...options,
  });
};

/**
 * Retrieve the measured charging power so far for the authenticated driver's active transaction.
 * Returns the quarter-hourly average charging power measured between the start of the driver's currently active transaction and now. Requires driver authentication.
 */
export const getDriverTransactionMeasurements = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetDriverTransactionMeasurementsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetDriverTransactionMeasurementsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/driver/transaction/measurements",
    ...options,
  });
};

/**
 * Submit driver charging preferences for the active transaction.
 */
export const submitDriverInput = <ThrowOnError extends boolean = false>(
  options: Options<SubmitDriverInputData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SubmitDriverInputResponse,
    SubmitDriverInputError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/driver/driver-input",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Retrieve the charging schedule for the authenticated driver.
 * Returns the optimized charging schedule for the driver's currently active transaction. Requires driver authentication.
 */
export const getDriverSchedule = <ThrowOnError extends boolean = false>(
  options?: Options<GetDriverScheduleData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetDriverScheduleResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/driver/schedule",
    ...options,
  });
};

/**
 * Evvehiclerouter.Get Makes
 */
export const getEvVehicleMakes = <ThrowOnError extends boolean = false>(
  options?: Options<GetEvVehicleMakesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetEvVehicleMakesResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/ev-vehicles/makes",
    ...options,
  });
};

/**
 * Evvehiclerouter.Get Models
 */
export const getEvVehicleModels = <ThrowOnError extends boolean = false>(
  options: Options<GetEvVehicleModelsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetEvVehicleModelsResponse,
    GetEvVehicleModelsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/ev-vehicles/makes/{make_slug}/models",
    ...options,
  });
};

/**
 * Evvehiclerouter.Get Variants
 */
export const getEvVehicleVariants = <ThrowOnError extends boolean = false>(
  options: Options<GetEvVehicleVariantsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetEvVehicleVariantsResponse,
    GetEvVehicleVariantsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/ev-vehicles/makes/{make_slug}/models/{model_slug}/variants",
    ...options,
  });
};

/**
 * Evvehiclerouter.Get Vehicle
 */
export const getEvVehicle = <ThrowOnError extends boolean = false>(
  options: Options<GetEvVehicleData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetEvVehicleResponse,
    GetEvVehicleError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/ev-vehicles/{unique_code}",
    ...options,
  });
};

/**
 * Pxcadminrouter.Create Token
 */
export const pxcAdminRouterCreateTokenV1PxcTokensPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PxcAdminRouterCreateTokenV1PxcTokensPostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PxcAdminRouterCreateTokenV1PxcTokensPostResponse,
    PxcAdminRouterCreateTokenV1PxcTokensPostError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/pxc/tokens/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Pxcadminrouter.Delete Token
 */
export const pxcAdminRouterDeleteTokenV1PxcTokensTokenIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PxcAdminRouterDeleteTokenV1PxcTokensTokenIdDeleteData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).delete<
    PxcAdminRouterDeleteTokenV1PxcTokensTokenIdDeleteResponse,
    PxcAdminRouterDeleteTokenV1PxcTokensTokenIdDeleteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/pxc/tokens/{token_id}",
    ...options,
  });
};

/**
 * Ocppconfigurationrouter.Get Configurations
 */
export const getOcppConfigurations = <ThrowOnError extends boolean = false>(
  options?: Options<GetOcppConfigurationsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOcppConfigurationsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/ocpp/configuration/",
    ...options,
  });
};

/**
 * Ocppconfigurationrouter.Create Configuration
 */
export const createOcppConfiguration = <ThrowOnError extends boolean = false>(
  options: Options<CreateOcppConfigurationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateOcppConfigurationResponse,
    CreateOcppConfigurationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/ocpp/configuration/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Ocppconfigurationrouter.Get Active Sockets
 */
export const getOcppActiveSocketsForSite = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetOcppActiveSocketsForSiteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetOcppActiveSocketsForSiteResponse,
    GetOcppActiveSocketsForSiteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/ocpp/configuration/{site_id}/active-sockets",
    ...options,
  });
};

/**
 * Ocppconfigurationrouter.Get Configuration
 */
export const getOcppConfiguration = <ThrowOnError extends boolean = false>(
  options: Options<GetOcppConfigurationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetOcppConfigurationResponse,
    GetOcppConfigurationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/ocpp/configuration/{site_id}",
    ...options,
  });
};

/**
 * Ocppconfigurationrouter.Delete Configuration
 */
export const deleteOcppConfiguration = <ThrowOnError extends boolean = false>(
  options: Options<DeleteOcppConfigurationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    unknown,
    DeleteOcppConfigurationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/ocpp/configuration/{configuration_id}",
    ...options,
  });
};

/**
 * Ocppconfigurationrouter.Update Configuration
 */
export const updateOcppConfiguration = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOcppConfigurationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateOcppConfigurationResponse,
    UpdateOcppConfigurationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/ocpp/configuration/{configuration_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Ocppconfigurationrouter.Update Socket To Asset Map
 */
export const updateSocketToAssetMap = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSocketToAssetMapData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateSocketToAssetMapResponse,
    UpdateSocketToAssetMapError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/ocpp/configuration/{configuration_id}/socket-to-asset-map",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Ocppconfigurationrouter.Get Socket Mapping Suggestions
 */
export const getSocketMappingSuggestions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetSocketMappingSuggestionsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSocketMappingSuggestionsResponse,
    GetSocketMappingSuggestionsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/ocpp/configuration/{site_id}/socket-mapping-suggestions",
    ...options,
  });
};

/**
 * Ocppmessagerouter.List Messages
 */
export const listOcppMessages = <ThrowOnError extends boolean = false>(
  options: Options<ListOcppMessagesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    ListOcppMessagesResponse,
    ListOcppMessagesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/ocpp/messages/",
    ...options,
  });
};

/**
 * Ocppmessagerouter.Diagnose Transaction Linking
 */
export const diagnoseOcppTransactionLinking = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DiagnoseOcppTransactionLinkingData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    DiagnoseOcppTransactionLinkingResponse,
    DiagnoseOcppTransactionLinkingError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/ocpp/messages/transaction-linking/{site_id}/{transaction_id}",
    ...options,
  });
};

/**
 * Benefitreportrouter.List Reports
 */
export const benefitReportRouterListReportsV1BenefitReportsSiteIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    BenefitReportRouterListReportsV1BenefitReportsSiteIdGetData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).get<
    BenefitReportRouterListReportsV1BenefitReportsSiteIdGetResponse,
    BenefitReportRouterListReportsV1BenefitReportsSiteIdGetError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/benefit-reports/{site_id}",
    ...options,
  });
};

/**
 * Benefitreportrouter.Get Report
 */
export const benefitReportRouterGetReportV1BenefitReportsSiteIdYearMonthGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    BenefitReportRouterGetReportV1BenefitReportsSiteIdYearMonthGetData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).get<
    BenefitReportRouterGetReportV1BenefitReportsSiteIdYearMonthGetResponse,
    BenefitReportRouterGetReportV1BenefitReportsSiteIdYearMonthGetError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/benefit-reports/{site_id}/{year}/{month}",
    ...options,
  });
};

/**
 * Alertsubscriptionrouter.List Alert Subscriptions
 */
export const alertSubscriptionRouterListAlertSubscriptionsV1AlertSubscriptionsGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      AlertSubscriptionRouterListAlertSubscriptionsV1AlertSubscriptionsGetData,
      ThrowOnError
    >,
  ) => {
    return (options?.client ?? _heyApiClient).get<
      AlertSubscriptionRouterListAlertSubscriptionsV1AlertSubscriptionsGetResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/v1/alert-subscriptions/",
      ...options,
    });
  };

/**
 * Alertsubscriptionrouter.Create Alert Subscription
 */
export const alertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      AlertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPostData,
      ThrowOnError
    >,
  ) => {
    return (options.client ?? _heyApiClient).post<
      AlertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPostResponse,
      AlertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPostError,
      ThrowOnError
    >({
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/v1/alert-subscriptions/",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    });
  };

/**
 * Alertsubscriptionrouter.Delete Alert Subscription
 */
export const alertSubscriptionRouterDeleteAlertSubscriptionV1AlertSubscriptionsIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      AlertSubscriptionRouterDeleteAlertSubscriptionV1AlertSubscriptionsIdDeleteData,
      ThrowOnError
    >,
  ) => {
    return (options.client ?? _heyApiClient).delete<
      unknown,
      AlertSubscriptionRouterDeleteAlertSubscriptionV1AlertSubscriptionsIdDeleteError,
      ThrowOnError
    >({
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/v1/alert-subscriptions/{id}",
      ...options,
    });
  };

/**
 * Alertsubscriptionrouter.Get Alert Subscription
 */
export const alertSubscriptionRouterGetAlertSubscriptionV1AlertSubscriptionsIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      AlertSubscriptionRouterGetAlertSubscriptionV1AlertSubscriptionsIdGetData,
      ThrowOnError
    >,
  ) => {
    return (options.client ?? _heyApiClient).get<
      AlertSubscriptionRouterGetAlertSubscriptionV1AlertSubscriptionsIdGetResponse,
      AlertSubscriptionRouterGetAlertSubscriptionV1AlertSubscriptionsIdGetError,
      ThrowOnError
    >({
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/v1/alert-subscriptions/{id}",
      ...options,
    });
  };

/**
 * Alertsubscriptionrouter.Update Alert Subscription
 */
export const alertSubscriptionRouterUpdateAlertSubscriptionV1AlertSubscriptionsIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      AlertSubscriptionRouterUpdateAlertSubscriptionV1AlertSubscriptionsIdPutData,
      ThrowOnError
    >,
  ) => {
    return (options.client ?? _heyApiClient).put<
      AlertSubscriptionRouterUpdateAlertSubscriptionV1AlertSubscriptionsIdPutResponse,
      AlertSubscriptionRouterUpdateAlertSubscriptionV1AlertSubscriptionsIdPutError,
      ThrowOnError
    >({
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/v1/alert-subscriptions/{id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    });
  };

/**
 * Email Pleevi engineering to request a go-live review
 */
export const requestSiteGoLive = <ThrowOnError extends boolean = false>(
  options: Options<RequestSiteGoLiveData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    RequestSiteGoLiveResponse,
    RequestSiteGoLiveError,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/v1/sites/{site_id}/go-live-request",
    ...options,
  });
};
